export function ReadOnlyOverlay() {
    return <div className="absolute top-0 z-10 !m-0 size-full cursor-default p-0"></div>;
}
